export const CHECK_AUTH = 'CHECK_AUTH';
export const LOGIN = 'login';
export const LOGOUT = 'logout';
export const FETCH_USERS = 'fetch_users';
export const FETCH_ROLES = 'fetch_roles';
export const CLEAR_ROLES_ACTION = 'clear_roles_action';
export const CLEAR_USERS_ACTION = 'clear_users_action';
export const REGISTER = 'register';
export const UPDATE_USER = 'updateUser';
export const DELETE_USER = 'deleteUser';
export const FETCH_ACCESOS = 'fetchAccesos';
export const CLEAR_ACCESOS_ACTION = 'clearAccesosAction';
export const SEND_ACCESO = 'sendAcceso';
export const SEND_ENTRY = 'sendEntry';
export const SEND_RESIDENT = 'sendResident';
export const FETCH_RESIDENTES = 'fetchResidentes';
export const CLEAR_RESIDENTES_ACTION = 'clearResidentesAction';
export const SEND_DESARROLLO = 'sendDesarrollo';
export const SEND_VIVIENDA = 'sendVivienda';
export const FETCH_VIVIENDAS = 'fetchViviendas';
export const CLEAR_VIVIENDAS_ACTION = 'clearViviendasAction';
export const FETCH_SUBCONDOMINIOS = 'fetchSubcondominios';
export const FETCH_DESARROLLOS = 'fetchDesarrollos';
export const FETCH_RESIDENT_INFO = 'fetchResidentInfo';
export const FETCH_VIVIENDA_INFO = 'fetchViviendaInfo';
export const ASOCIATE_RESIDENT = 'asociateResident';
export const DELETE_ASOC_ACTION = 'deleteAsocAction';
export const CANCEL_ACCESO_ACTION = 'cancelAccesoAction';
export const CLEAR_COLABORADORES_ACTION = 'clearColaboradoresAction';
export const FETCH_COLABORADORES = 'fetchColaboradores';
export const FETCH_COLLABORATOR_INFO = 'fetchCollaboratorInfo';
export const SEND_COLLABORATOR = 'sendCollaborator';
export const SEND_FILES = 'sendFiles';
export const SEND_CAPTURES = 'sendCaptures';
export const SEND_SIGNATURES = 'sendSignatures';
export const SEND_FINGERPRINTERS = 'sendFingerprinters';
export const SEND_RESIDENT_APPLICATION = 'sendResidentApplication';
export const SEND_PWD_RESIDENT_APPLICATION = 'sendPwdResidentApplication';
export const CLOSE_SESSION_RESIDENT_APPLICATION = 'closeSessionResidentApplication';
export const CLEAR_VEHICULOS_ACTION = 'clearVehiculosAction';
export const FETCH_VEHICULOS = 'fetchVehiculos';
export const SEND_VEHICULO = 'sendVehiculo';
export const FETCH_VEHICULO_INFO = 'fetchVehiculoInfo';
export const FETCH_ACCESO_DETALLES = 'fetchAccesoDetalles';
export const DELETE_RESIDENT = 'deleteResident';
export const DELETE_ASOC_VEHICLE_ACTION = 'deleteAsocVehicleAction';
export const FETCH_PREREGISTROS = 'fetchPreregistros';
export const CLEAR_PREREGISTROS_ACTION = 'clearPreregistrosAction';
export const FETCH_PREREGISTRO_INFO = 'fetchPreregistroInfo';
export const SEND_PREREGISTRO = 'sendPreregistro';
export const DELETE_VIVIENDA = 'deleteVivienda';
export const FETCH_FRONT_IMAGE = 'fetchFrontImage';
export const FETCH_IMAGE = 'fetchImage';
export const FETCH_SIDE_IMAGE = 'fetchSideImage';
export const FETCH_BACK_IMAGE = 'fetchBackImage';
export const FETCH_FACE_IMAGE = 'fetchFaceImage';
export const FETCH_CREDENTIAL_IMAGE = 'fetchCredentialImage';
export const FETCH_BACK_CREDENTIAL_IMAGE = 'fetchBackCredentialImage';
export const FETCH_ATTENDANCE = 'fetchAttendance';
export const FETCH_RH_COLLABORATORS = 'fetchRhCollaborators';
export const FETCH_VACATIONS = 'fetchRhVacations';
export const FETCH_INCAPACITIES = 'fetchRhIncapacities';
export const FETCH_ABSENCES = 'fetchRhAbsences';
export const ADD_VACATION = 'addRhVacation';
export const ADD_INCAPACITY = 'addRhIncapacity';
export const ADD_ABSENCE = 'addRhAbscence';
export const REMOVE_ABSENCE = 'removeRhAbscence';
export const REMOVE_INCAPACITY = 'removeRhIncapacity';
export const REMOVE_VACATION = 'removeRhVacation';
export const FETCH_PORTICOS = 'fetchPorticos';
export const FETCH_PORTICO_DETAIL = 'fetchPorticoDetail';
export const FETCH_PORTICOS_SUBCONDOMINIOS = 'fetchPorticosSubcondominios';
export const SET_PORTICO_SUBCONDOMINIOS = 'setPorticoSubcondominios';
export const REMOVE_TURNO_DOBLE = 'removeRhTurnoDoble';
export const ADD_TURNO_DOBLE = 'addRhTurnoDoble';
export const FETCH_TURNOS_DOBLES = 'fetchRhTurnosDobles';
export const REMOVE_DESCANSO = 'removeRhDescanso';
export const ADD_DESCANSO = 'addRhDescanso';
export const FETCH_DESCANSOS = 'fetchRhDescanso';
export const FETCH_DESEMPENIOS = 'fetchRhDesempenios';
export const ADD_DESEMPENIO = 'addRhDesempenio';
export const REMOVE_DESEMPENIO = 'removeRhDesempenio';
export const FETCH_INCIDENCIAS = 'fetchRhIncidencias';
export const ADD_INCIDENCIA = 'addRhIncidencia';
export const REMOVE_INCIDENCIA = 'removeRhIncidencia';
export const FETCH_FORMACIONES = 'fetchRhFormaciones';
export const ADD_FORMACION = 'addRhFormaciones';
export const REMOVE_FORMACION = 'removeRhFormaciones';
export const FETCH_AVISOS = 'fetchAvisos';
export const CREATE_AVISO = 'createAviso';
export const LISTAR_SUBCONDOMINIOS_AVISOS = 'listarSubcondominiosAvisos';
export const NOTIFICAR_AVISO = 'notifyAviso';
export const OBTENER_ARCHIVO_AVISO = 'obtenerArchivoAviso';
export const FETCH_DETALLE_AVISOS = 'obtenerDetalleAviso';
export const CREATE_REGLAMENTO = 'createReglamento';
export const FETCH_REGLAMENTOS = 'fetchReglamentos';
export const OBTENER_ARCHIVO_REGLAMENTO = 'obtenerArchivoReglamento';
export const REMOVE_REGLAMENTO = 'deleteReglamento';
export const REMOVE_AVISO = 'deleteAviso';
export const FETCH_DOMESTICO_INFO = 'fetchDomesticoInfo';
export const SEND_DOMESTICO = 'sendDomestico';
export const CLEAR_DOMESTICOS_ACTION = 'clearDomesticosAction';
export const FETCH_DOMESTICOS = 'fetchDomesticos';
export const EDIT_DOMESTICO = 'editDomestico';
export const CLEAR_MASCOTAS_ACTION = 'clearMascotasAction';
export const FETCH_MASCOTAS = 'fetchMascotas';
export const FETCH_MASCOTA_INFO = 'fetchMascotaInfo';
export const DELETE_MASCOTA = 'deleteMascota';
export const SEND_MASCOTA = 'sendMascota';
export const EDIT_MASCOTA = 'editMascota';
export const FETCH_LICENCIA_INFO = 'fetchLicenciaInfo';
export const SEND_LICENCIA = 'sendLicencia';
export const EDIT_LICENCIA = 'editLicencia';
export const CLEAR_LICENCIAS_ACTION = 'clearLicenciasAction';
export const FETCH_LICENCIAS = 'fetchLicencias';
export const DELETE_LICENCIA = 'deleteLicencia';
